'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Section(_ref) {
  var className = _ref.className,
      density = _ref.density,
      padding = _ref.padding,
      theme = _ref.theme,
      children = _ref.children,
      contentSize = _ref.contentSize,
      props = _objectWithoutProperties(_ref, ['className', 'density', 'padding', 'theme', 'children', 'contentSize']);

  var classes = (0, _classnames2.default)('section', density && 'section--density-' + density, contentSize && 'section--content-size-' + contentSize, theme && 'section--theme-' + theme, className);

  if (padding) {
    console.warn('Property padding is deprecated. Use density for vertical spacing');
  }

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    _react2.default.createElement(
      'div',
      { className: 'section__content' },
      children
    )
  );
}

Section.propTypes = {
  padding: _propTypes2.default.oneOf(['none', 'medium']),
  className: _propTypes2.default.string,
  density: _propTypes2.default.oneOf(['none', 'cozy']),
  theme: _propTypes2.default.oneOf(['white', 'light', 'dark', 'yellow']),
  contentSize: _propTypes2.default.oneOf(['default', 'expanded']),
  children: _propTypes2.default.node
};

Section.defaultProps = {
  contentSize: 'default',
  density: 'cozy'
};

exports.default = Section;